<script>
import Api from "api-client";

export default {
  name: "PasswordChangeComponent",

  data() {
    return {
      errorMsg: undefined,

      passwordForm: {
        oldPassword: undefined,
        newPassword: undefined,
        newPasswordAgain: undefined
      }
    }
  },

  methods: {
    saveNewPassword() {
      if (this.haveUnpopulatedPasswordField) {
        this.errorMsg = "Kérlek töltsd ki az összes mezőt!";
        return;
      }

      if (this.passwordForm.newPassword != this.passwordForm.newPasswordAgain) {
        this.errorMsg = "A beírt jelszavak nem egyeznek!";
        return;
      }

      Api.changePassword(this.passwordForm.oldPassword, this.passwordForm.newPassword)
          .then(() => {
            this.showSuccessToastMessage("Siker", "Sikeres jelszó csere!");
            this.logout();
          })
          .catch((err) => {
            if (err.response?.data?.message) {
              this.errorMsg = err.response.data.message;
            } else {
              console.error(err);
              this.errorMsg = "Api hiba";
            }
          });
    },

    showSuccessToastMessage(title, message) {
      this.$toast.success({title, message});
    },

    logout() {
      this.$store.dispatch("login/logout");
      document.title = this.$cte("profile.loginDocTitle");
      window.localStorage.clear();
      localStorage.removeItem('vuex');
      this.$router.push("/login");
      window.localStorage.clear();
    },
  },

  watch: {
    passwordForm: {
      handler() {
        this.errorMsg = undefined;
      },
      deep: true
    }
  },

  computed: {
    haveUnpopulatedPasswordField: function () {
      return (!this.passwordForm.oldPassword || this.passwordForm.length === 0) ||
          (!this.passwordForm.newPassword || this.passwordForm.newPassword.length === 0) ||
          (!this.passwordForm.newPasswordAgain || this.passwordForm.newPasswordAgain.length === 0);
    },
  }
}
</script>

<template>
  <div class="font-jumper">
    <div class="parent-div">
      <div class="ml-3 mt-5 d-flex">
        <span class="pt-2 password-label-width">Régi jelszó:</span>
        <b-form-input
            v-model="passwordForm.oldPassword"
            class="w-100"
            type="password"
            id="company-taxNumber-input"/>
      </div>

      <div class="ml-3 mt-3 d-flex">
        <span class="pt-2 password-label-width">Új jelszó:</span>
        <b-form-input
            v-model="passwordForm.newPassword"
            class="w-100"
            type="password"
            id="company-taxNumber-input"/>
      </div>

      <div class="ml-3 mt-3 d-flex">
        <span class="pt-2 password-label-width">Új jelszó ismét:</span>
        <b-form-input
            v-model="passwordForm.newPasswordAgain"
            class="w-100"
            type="password"
            id="company-taxNumber-input"/>
      </div>

      <div class="d-flex mt-3">
        <div v-if="errorMsg" class="text-danger font-weight-bold mt-1 pl-3">{{errorMsg}}</div>
        <b-button
            @click="saveNewPassword"
            class="ml-auto"
            variant="primary"
        >{{ $cte("common.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.parent-div {
  max-width: 550px;
}

.password-label-width {
  width: 160px
}
</style>